import React from 'react'
import ReactAudioPlayer from 'react-audio-player';
const ModalRecurso = ({dataRecurso}) => {
 // console.log(dataRecurso)
    return (
      <div
        className="modal fade bd-example-modal-lg"
        style={{ backgroundColor: "rgba(41,48,59,.6)" }}
        id="modal-recurso"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg modal-video"
          style={{ maxWidth: "700px" }}
        >
          <div className="modal-content" style={{ background: "#29303b" }}>
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <h5 className="modal-title text-white" id="exampleModalLabel">
                {dataRecurso.nombre_archivo}
              </h5>
              <button
                type="button"
                className="close text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-content" style={{ background: "#29303b" }}>
              <div className="d-flex justify-content-center align-items-center" style={{height:'400px'}} >
              { dataRecurso.ruta_archivo && <ReactAudioPlayer src={`${process.env.REACT_APP_API_URL}/${dataRecurso.ruta_archivo}`} controls  /> }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}
 
export default ModalRecurso;